'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './resident-directory.routes';

export class ResidentDirectoryComponent {
  constructor(IntegrationService, DTOptionsBuilder, $state, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Resident Directory");

    this.contactTypes = Config.getModuleConfig(Config.Modules.Directories).getResidentDirectoryContactTypes();

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Resident Directory'
      },{
        extend: 'csv',
        title: 'Resident Directory'
      },{
        title: 'Resident Directory',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);

    this.data = [];

    IntegrationService.queryResidentDirectory(data => {

      data.forEach(ppty => {

        ppty.contacts
          .filter(contact => this.contactTypes.includes(contact.type))
          .forEach(contact => {

            if (!contact.contact || contact.contact.hideInDirectory)
              return;

            this.data.push({
              firstName: contact.contact.firstName,
              middleName: contact.contact.middleName,
              lastName: contact.contact.lastName,
              company: contact.contact.company,
              unit: ppty.lotNo,
              address: [ppty.address],
              phone: (contact.contact.phone && contact.contact.phone.length) ? contact.contact.phone.filter(o => !o.isPrivate) : [],
              email: (contact.contact.email && contact.contact.email.length) ? contact.contact.email.filter(o => !o.isPrivate) : []
            });

        });

      });

    });
  }

  getPrimaryAddress(contact, onlyStreet="true") {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    if (onlyStreet)
      return address.street;

    return address.street + "<br/>" + address.city + ', ' + address.state + ' ' + address.zip;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }
}

export default angular.module('conduuApp.residentDirectory', [uiRouter])
  .config(routes)
  .component('residentDirectory', {
    template: require('./resident-directory.html'),
    controller: ResidentDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/resident/resident-directory.component.js